import React, { Dispatch, createContext, useContext, useRef } from 'react'
import useDebounce from 'react-use/lib/useDebounce'

export type AffirmProviderAction = {
  type: 'REFRESH_AFFIRM'
}

export const AffirmProviderContext = createContext<
  | {
      refreshAffirm: () => void
    }
  | undefined
>(undefined)

export const AffirmProviderProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const prevStamp = useRef<number | null>(null)
  const updateStamp = useRef<number | null>(null)

  useDebounce(
    () => {
      if (!updateStamp.current) return
      if (updateStamp.current && prevStamp.current) return

      prevStamp.current = updateStamp.current

      window.affirm.ui.ready(() => {
        window.affirm.ui.refresh()

        setTimeout(() => {
          document
            .querySelectorAll('a.affirm-modal-trigger')
            ?.forEach((link) => link.setAttribute('href', '#'))
        }, 2000)
      })
    },
    2,
    [updateStamp.current]
  )

  const refreshAffirm = () => {
    updateStamp.current = new Date().getTime()
  }

  return (
    <AffirmProviderContext.Provider value={{ refreshAffirm }}>
      {children}
    </AffirmProviderContext.Provider>
  )
}

export const useAffirmProvider = () => {
  const context = useContext(AffirmProviderContext)

  if (!context) {
    throw new Error(
      'useAffirmProvider must be used within a RefreshAffirmProvider'
    )
  }

  return context
}
